import React from 'react';
import { useRouter } from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

export interface IRecommendedTariff {
    id: number,
    title?: string,
    body?: string,
    sort?: number,
    url_landing?: string,
    title_short?: string,
    title_same?: string,
    title_body?: string,
    title_color_same?: string,
    desc_same?: string,
    body_full?: string,
    alias?: string,
    body_for_line_page?: string,
    image_background?: string,
    image_background_webp?: string,
    background_same?: string,
    image_promo?: string,
    image_promo_webp?: string,
    button_text?: string,
}

export interface IProps {
    tariff: IRecommendedTariff,
}

const SameTariffLineCard = ({ tariff }: IProps) => {
    const router = useRouter();

    const handleClick = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.tariffLines,
            action: 'click choose lines',
            label: '',
        });
        router.push(`/internet/${tariff.alias}`);
    };
    return (
        <ST.CardWrapper onClick={handleClick} withCellSpacing={true}>
            <ST.Header backgroundColor={tariff.background_same}>
                <ST.HeaderText
                    color={tariff.title_color_same}
                    dangerouslySetInnerHTML={{ __html: tariff.desc_same || '' }}
                />
                <ST.HeaderImage>
                    <WebpImage urlWebp={tariff.image_promo_webp}>
                        <img src={tariff.image_promo} alt={tariff.title}/>
                    </WebpImage>
                </ST.HeaderImage>
            </ST.Header>
            <ST.Bottom>
                <ST.Text dangerouslySetInnerHTML={{ __html: tariff.title_same || '' }}/>
            </ST.Bottom>
        </ST.CardWrapper>
    );
};

export default SameTariffLineCard;
